import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e97f56c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex no-wrap items-center all-pointer-events"
}
const _hoisted_2 = { class: "error-text" }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, {
    ref: "selectRef",
    label: _ctx.control.uischema?.options?.itemLabel || _ctx.control.label || _ctx.itemLabel,
    required: _ctx.control.required,
    error: _ctx.isTouched && _ctx.hasError,
    "model-value": _ctx.control.data,
    onInputValue: _ctx.changeInputText,
    outlined: "",
    dense: "",
    loading: _ctx.control?.uischema?.options?.loading || false,
    "use-input": "",
    "reactive-rules": "",
    "bg-color": "white",
    "use-chips": "",
    disable: _ctx.control.uischema?.options?.readOnly,
    multiple: "",
    options: _ctx.stringOptions.length > 5 ? _ctx.stringOptions : [],
    onNewValue: _ctx.createValue,
    "input-debounce": "0",
    "options-dense": "",
    "new-value-mode": "add",
    hint: _ctx.control.description || '',
    class: "q-pb-none input-form ip-input",
    "onUpdate:modelValue": _ctx.onChange,
    onKeydown: _withKeys(_withModifiers(_ctx.onEnterPress, ["stop","prevent"]), ["enter"]),
    onBlur: _ctx.onBlur,
    onFocus: _ctx.onFocus
  }, _createSlots({
    error: _withCtx(() => [
      (_ctx.errorMessage?.length > 35)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_q_icon, {
              class: "q-mr-xs",
              size: "12px",
              name: "error",
              color: "negative"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, {
                  class: "bg-negative",
                  anchor: "top left",
                  self: "bottom left",
                  offset: [0, 8]
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.errorMessage), 1)
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
    ]),
    _: 2
  }, [
    (_ctx.control.uischema?.options?.tooltip)
      ? {
          name: "append",
          fn: _withCtx(() => [
            _createVNode(_component_q_icon, {
              name: "help_outline",
              class: "cursor-pointer"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.control.uischema?.options?.tooltip), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        }
      : undefined
  ]), 1032, ["label", "required", "error", "model-value", "onInputValue", "loading", "disable", "options", "onNewValue", "hint", "onUpdate:modelValue", "onKeydown", "onBlur", "onFocus"]))
}